var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"favorite"},[_c('h1',[_vm._v("我的收藏")]),(!_vm.hasFavCards)?_c('p',{staticClass:"noCards"},[_vm._v(" 還沒有收藏的單字, 快來收集喜歡或不熟悉的單字吧 ")]):_vm._e(),_c('Cards',{on:{"getFav":_vm.getFav,"noFav":_vm.noFav}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }